import { useQuery } from "@tanstack/react-query";
import { useGeotabClient } from "@/components/GeotabClientContext";

const RESULTS_LIMIT = 50000;

/**
 * All company cards registered in the database. Asking only for the ones valid right now hides
 * expired cards, and an expired company card is exactly what the user needs to see.
 */
export function useTachographCompanyCards() {
  const { geotabClient, activeSessionId } = useGeotabClient();

  return useQuery({
    queryKey: ["tachographCompanyCards", activeSessionId],

    queryFn: ({ signal }) => geotabClient.get("TachographCompanyCard", {}, RESULTS_LIMIT, signal),
  });
}
